/**
 * Branded ID types. The brand is a phantom property — never present at
 * runtime — that makes the compiler refuse `customerId = dealerId` even
 * though both are strings underneath.
 *
 * IDs are minted by `mintId(prefix)` for tests/bootstrap; in production the
 * database mints UUIDs and we wrap incoming strings via `<Foo>Id.of(raw)`
 * which validates UUID shape.
 */
import { z } from "zod";
const uuidSchema = z.string().uuid();
function makeBrand(_brand) {
    return {
        of(raw) {
            uuidSchema.parse(raw);
            return raw;
        },
        toString(id) {
            return id;
        },
    };
}
export const CountryId = makeBrand("CountryId");
export const CustomerId = makeBrand("CustomerId");
export const DealerId = makeBrand("DealerId");
export const DealerAgentId = makeBrand("DealerAgentId");
export const DeviceId = makeBrand("DeviceId");
export const LoanId = makeBrand("LoanId");
export const ContractId = makeBrand("ContractId");
export const PaymentId = makeBrand("PaymentId");
export const PaymentIntentId = makeBrand("PaymentIntentId");
export const LedgerEntryId = makeBrand("LedgerEntryId");
export const LockEventId = makeBrand("LockEventId");
export const UnlockCodeId = makeBrand("UnlockCodeId");
export const AuditEntryId = makeBrand("AuditEntryId");
export const LocationSignalId = makeBrand("LocationSignalId");
export const ImportRunId = makeBrand("ImportRunId");
export const ActorId = makeBrand("ActorId");
export const PolicyVersionId = makeBrand("PolicyVersionId");
//# sourceMappingURL=ids.js.map